import { SidebarListItem as SidebarListItemSource } from '@bufferapp/ui';
import styled from 'styled-components';

export const SidebarListItem = styled(SidebarListItemSource)`
  margin-bottom: 4px;
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 0;
`;

export const BagdesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
